import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16536 15.6312V22C9.16536 22.5523 8.71765 23 8.16536 23H4.03203C2.81701 23 1.83203 22.0633 1.83203 20.9078V8.84184C1.83203 8.39036 2.06183 7.96679 2.44873 7.70515L11.9821 1.2581C12.4909 0.913967 13.1731 0.913967 13.682 1.2581L23.2153 7.70515C23.6022 7.96679 23.832 8.39036 23.832 8.84184V20.9078C23.832 22.0633 22.8471 23 21.632 23H17.4987C16.9464 23 16.4987 22.5523 16.4987 22V15.6312C16.4987 14.8609 15.842 14.2364 15.032 14.2364H10.632C9.82201 14.2364 9.16536 14.8609 9.16536 15.6312Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeOpacity: .2,
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16536 15.6312V22C9.16536 22.5523 8.71765 23 8.16536 23H4.03203C2.81701 23 1.83203 22.0633 1.83203 20.9078V8.84184C1.83203 8.39036 2.06183 7.96679 2.44873 7.70515L11.9821 1.2581C12.4909 0.913967 13.1731 0.913967 13.682 1.2581L23.2153 7.70515C23.6022 7.96679 23.832 8.39036 23.832 8.84184V20.9078C23.832 22.0633 22.8471 23 21.632 23H17.4987C16.9464 23 16.4987 22.5523 16.4987 22V15.6312C16.4987 14.8609 15.842 14.2364 15.032 14.2364H10.632C9.82201 14.2364 9.16536 14.8609 9.16536 15.6312Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeOpacity: .2,
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16536 15.6312V22C9.16536 22.5523 8.71765 23 8.16536 23H4.03203C2.81701 23 1.83203 22.0633 1.83203 20.9078V8.84184C1.83203 8.39036 2.06183 7.96679 2.44873 7.70515L11.9821 1.2581C12.4909 0.913967 13.1731 0.913967 13.682 1.2581L23.2153 7.70515C23.6022 7.96679 23.832 8.39036 23.832 8.84184V20.9078C23.832 22.0633 22.8471 23 21.632 23H17.4987C16.9464 23 16.4987 22.5523 16.4987 22V15.6312C16.4987 14.8609 15.842 14.2364 15.032 14.2364H10.632C9.82201 14.2364 9.16536 14.8609 9.16536 15.6312Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeOpacity: .2,
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16536 15.6312V22C9.16536 22.5523 8.71765 23 8.16536 23H4.03203C2.81701 23 1.83203 22.0633 1.83203 20.9078V8.84184C1.83203 8.39036 2.06183 7.96679 2.44873 7.70515L11.9821 1.2581C12.4909 0.913967 13.1731 0.913967 13.682 1.2581L23.2153 7.70515C23.6022 7.96679 23.832 8.39036 23.832 8.84184V20.9078C23.832 22.0633 22.8471 23 21.632 23H17.4987C16.9464 23 16.4987 22.5523 16.4987 22V15.6312C16.4987 14.8609 15.842 14.2364 15.032 14.2364H10.632C9.82201 14.2364 9.16536 14.8609 9.16536 15.6312Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeOpacity: .2,
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIcHome;
